export const ACTIONS:any = {
	DELETE: 'delete',
	EDIT: 'edit',
}

